export const DAY_START = 6 * 60;   // 06:00
export const DAY_END = 22 * 60;    // 22:00
export const STEP = 15;

export const pad = (n) => String(n).padStart(2, '0');
export const toHHMM = (mins) => `${pad(Math.floor(mins / 60))}:${pad(mins % 60)}`;
export const fromHHMM = (s) => { if (!s) return null; const [h, m] = s.split(':').map(Number); return h * 60 + m; };
export const fmtHours = (mins) => {
  const h = Math.floor((mins || 0) / 60); const m = (mins || 0) % 60;
  if (!h) return `${m}m`;
  return m ? `${h}h ${m}m` : `${h}h`;
};
export const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const parseIso = (s) => { const [y, m, d] = s.split('-').map(Number); return new Date(y, m - 1, d); };
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const startOfWeek = (d) => { const x = new Date(d); const day = (x.getDay() + 6) % 7; x.setDate(x.getDate() - day); x.setHours(0, 0, 0, 0); return x; };
export const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
export const endOfMonth = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 0);
export const todayIso = () => iso(new Date());
export const fmtDay = (d, opts = { weekday: 'short', day: 'numeric', month: 'short' }) => d.toLocaleDateString('en-GB', opts);
export const rangeFor = (view, anchor) => {
  if (view === 'day') return [anchor, anchor];
  if (view === 'week') { const s = startOfWeek(anchor); return [s, addDays(s, 6)]; }
  const s = startOfMonth(anchor);
  return [startOfWeek(s), addDays(startOfWeek(endOfMonth(anchor)), 6)];
};
export const textOn = (hex) => {
  if (!hex) return '#fff';
  const n = parseInt(hex.slice(1), 16);
  const r = (n >> 16) & 255; const g = (n >> 8) & 255; const b = n & 255;
  return (r * 299 + g * 587 + b * 114) / 1000 > 160 ? '#111827' : '#fff';
};
